// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2287":"a63c2641","7441":"ad26fab6"}[chunkId] + ".chunk.css";
};